'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';


import { useState } from 'react';
import Image from '@eliadmin/core/src/components/image/image-wrapped';
import { LightboxComponent } from '@eliadmin/core/src/components/lightbox/lightbox-component';
import { useDisclosure } from '@eliadmin/core/src/hooks/use-disclosure';
import type { ReferenceDetail } from '@eliadmin/core/src/api/references/references-types';

export function ReferenceImage({ reference }: { reference: ReferenceDetail }) {
  const { isOpen, setIsOpen } = useDisclosure(false);
  const [imagesSorted, setImagesSorted] = useState<{ url: string; name: string }[]>([]);

  const handleOpenGallery = (images: any, index: number) => () => {
    if (Array.isArray(images) && index >= 0 && index < images.length) {
      const newImages = [...images.slice(index), ...images.slice(0, index)];
      setImagesSorted(newImages);
      setIsOpen(true);
    } else if (images && !Array.isArray(images)) {
      setImagesSorted([images]);
      setIsOpen(true);
    }
  };

  return (
    <>
      <LightboxComponent isOpen={isOpen} setIsOpen={setIsOpen} images={imagesSorted} />
      <Image
        onClick={handleOpenGallery(reference.image, 0)}
        src={reference.image?.url ?? '/images/placeholder.png'}
        alt={resolveImageAlt(reference?.image, reference?.name)}
        width={0}
        height={0}
        className="h-auto w-full cursor-pointer overflow-hidden rounded-[16px] object-cover object-center sm:rounded-[20px] lg:rounded-[24px]"
        sizes="100vw"
        priority
        loading="eager"
      />
    </>
  );
}
